module.exports = __webpack_public_path__ + "img/kia.d1b3cad9.jpg";